<template>
    <svg width="12" height="16" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M10 6c0 .315-.175.96-.699 1.935-.492.916-1.173 1.905-1.89 2.842A40.518 40.518 0 016 12.515c-.434-.506-.924-1.1-1.412-1.738-.716-.937-1.397-1.926-1.89-2.842C2.176 6.96 2 6.315 2 6a4 4 0 118 0zm2 0c0 2.297-2.884 5.975-4.653 8.015A39.802 39.802 0 016 15.5s-.565-.582-1.347-1.485C2.883 11.975 0 8.297 0 6a6 6 0 1112 0zM6 7a1 1 0 100-2 1 1 0 000 2z" fill="#B6BCCA"/></svg>
</template>

<script>
  export default {
    name: "GeoIcon"
  }
</script>